import type { SimpleSearchQuery } from '@/shared/ui/search/SimpleSearch/types/search.types';
import type { PlannerSearchQuery, PlannerSearchFilterGroup } from '@/entities/planner';

export function defaultQuery(pageSize: number, cursor?: string): PlannerSearchQuery {
  return {
    filterGroups: [],
    sortBy: 'name',
    sortOrder: 'ASC',
    pageSize,
    cursor,
  };
}

/**
 * SimpleSearchQuery를 PlannerSearchQuery로 변환
 */
export function convertSimpleToPlannerQuery(
  simpleQuery: SimpleSearchQuery,
  cursor?: string,
  defaultFieldName: string = 'name'
): PlannerSearchQuery {
  const fieldName = simpleQuery.fieldName || defaultFieldName;
  const value = simpleQuery.value?.trim();

  const filterGroups: PlannerSearchFilterGroup[] = value
    ? [
        {
          logic: 'AND',
          filters: [
            {
              field: fieldName,
              operator: 'CONTAINS',
              value,
              values: null,
            },
          ],
        },
      ]
    : [];

  return {
    filterGroups,
    sortBy: 'name',
    sortOrder: 'ASC',
    pageSize: 20,
    cursor,
  };
}
